// extracted by mini-css-extract-plugin
module.exports = {"Display":"MainToolbar_Display__CT8TW","Header":"MainToolbar_Header__A_rki","Header__container":"MainToolbar_Header__container__1rDyu","Icon":"MainToolbar_Icon__1yBHY"};